const TOKEN_KEY = 'auth_token';
const LOGIN_KEY = 'auth_login';

export function getToken(): string | null {
  // Фолбэк на sessionStorage — для обратной совместимости со старыми сессиями,
  // сохранёнными до перехода на localStorage.
  return localStorage.getItem(TOKEN_KEY) ?? sessionStorage.getItem(TOKEN_KEY);
}

// Всегда localStorage: sessionStorage не шарится между вкладками,
// из-за чего ссылки, открытые в новой вкладке, требовали повторной авторизации.
export function setToken(token: string, _rememberMe?: boolean): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function removeToken(): void {
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
}

export function getLogin(): string | null {
  return localStorage.getItem(LOGIN_KEY) ?? sessionStorage.getItem(LOGIN_KEY);
}

export function setLogin(login: string, _rememberMe?: boolean): void {
  localStorage.setItem(LOGIN_KEY, login);
}

export function removeLogin(): void {
  localStorage.removeItem(LOGIN_KEY);
  sessionStorage.removeItem(LOGIN_KEY);
}
